import * as React from 'react';
import classnames from 'classnames';
import { Price } from '@grandvisionhq/common';

const ProductDetailPrice = ({ originalPrice , discountedPrice , currency , customSize , centAmount =true , className ,  })=>{
    if (originalPrice && discountedPrice && originalPrice !== discountedPrice) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Price, {
            value: discountedPrice,
            currency: currency,
            centAmount: centAmount,
            className: classnames('product-detail-price', className),
            size: customSize !== null && customSize !== void 0 ? customSize : 'large',
            type: "discount",
            "data-t": "price-discounted"
        }), /*#__PURE__*/ React.createElement(Price, {
            value: originalPrice,
            currency: currency,
            centAmount: centAmount,
            className: classnames('product-detail-price', className),
            size: customSize !== null && customSize !== void 0 ? customSize : 'large',
            type: "strikethrough",
            "data-t": "price-original"
        }));
    }
    return /*#__PURE__*/ React.createElement(Price, {
        value: originalPrice,
        currency: currency,
        centAmount: centAmount,
        size: customSize !== null && customSize !== void 0 ? customSize : 'large',
        className: "product-detail-price",
        "data-t": "price-original"
    });
};

export { ProductDetailPrice };
//# sourceMappingURL=ProductDetailPrice.js.map
